// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for printable documents */
.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 900px; /* Wider for more columns */
  margin: auto;
  background-color: #fff;
  color: #000;
}

.printable-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.printable-header h1 {
  margin: 0 0 5px 0;
  font-size: 1.8em;
}

.printable-header p {
  margin: 2px 0;
  font-size: 1em;
  color: #333;
}

section {
  margin-bottom: 25px;
}

section h2 {
  font-size: 1.3em;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #111;
}

/* Summary Section */
.summary-section .summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Adjust minmax */
  gap: 10px 20px;
  font-size: 0.95em;
  line-height: 1.5;
}

.summary-section .summary-grid div {
  padding: 5px 0;
}

.summary-section .summary-grid strong {
  color: #333;
}

/* Table Styling */
.details-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.85em; /* Slightly smaller font for more columns */
}

.details-table th,
.details-table td {
  border: 1px solid #ddd;
  padding: 6px; /* Slightly reduced padding */
  text-align: left;
  vertical-align: top;
}

.details-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Right-align numeric columns */
.details-table td:nth-child(3), /* Кол-во заказов */
.details-table td:nth-child(4), /* Общая сумма */
.details-table td:nth-child(5), /* Оплачено */
.details-table td:nth-child(6), /* Задолженность */
.details-table td:nth-child(7) { /* Ср. скидка */
  text-align: right;
}

.printable-footer {
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 0.8em;
  color: #555;
}

/* Print-specific styles */
@media print {
  body {
    margin: 0;
    padding: 0;
    background-color: #fff;
  }
  .printable-container {
    max-width: 100%;
    box-shadow: none;
    margin: 0;
    padding: 10mm;
    border: none;
    font-size: 9pt; /* Adjust base font size for print */
  }
  .printable-header h1 {
    font-size: 16pt;
  }
   .printable-header p {
    font-size: 10pt;
  }
  section h2 {
    font-size: 12pt;
  }
  .details-table th,
  .details-table td {
    border: 1px solid #aaa !important;
    padding: 4px; /* Further reduce padding for print */
  }
  tr, section, .summary-grid div {
    page-break-inside: avoid;
  }
  h1, h2 {
    page-break-after: avoid;
  }
  .no-print {
    /* display: none; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableClientReport.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D,EAAE,kBAAkB;EAC/E,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB,EAAE,2CAA2C;AAChE;;AAEA;;EAEE,sBAAsB;EACtB,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;;;;iCAIiC,eAAe;EAC9C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,cAAc,EAAE,oCAAoC;EACtD;EACA;IACE,eAAe;EACjB;GACC;IACC,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,iCAAiC;IACjC,YAAY,EAAE,qCAAqC;EACrD;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Basic styling for printable documents */\n.printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 900px; /* Wider for more columns */\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 15px;\n}\n\n.printable-header h1 {\n  margin: 0 0 5px 0;\n  font-size: 1.8em;\n}\n\n.printable-header p {\n  margin: 2px 0;\n  font-size: 1em;\n  color: #333;\n}\n\nsection {\n  margin-bottom: 25px;\n}\n\nsection h2 {\n  font-size: 1.3em;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #111;\n}\n\n/* Summary Section */\n.summary-section .summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Adjust minmax */\n  gap: 10px 20px;\n  font-size: 0.95em;\n  line-height: 1.5;\n}\n\n.summary-section .summary-grid div {\n  padding: 5px 0;\n}\n\n.summary-section .summary-grid strong {\n  color: #333;\n}\n\n/* Table Styling */\n.details-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 0.85em; /* Slightly smaller font for more columns */\n}\n\n.details-table th,\n.details-table td {\n  border: 1px solid #ddd;\n  padding: 6px; /* Slightly reduced padding */\n  text-align: left;\n  vertical-align: top;\n}\n\n.details-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n/* Right-align numeric columns */\n.details-table td:nth-child(3), /* Кол-во заказов */\n.details-table td:nth-child(4), /* Общая сумма */\n.details-table td:nth-child(5), /* Оплачено */\n.details-table td:nth-child(6), /* Задолженность */\n.details-table td:nth-child(7) { /* Ср. скидка */\n  text-align: right;\n}\n\n.printable-footer {\n  margin-top: 40px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n  text-align: center;\n  font-size: 0.8em;\n  color: #555;\n}\n\n/* Print-specific styles */\n@media print {\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #fff;\n  }\n  .printable-container {\n    max-width: 100%;\n    box-shadow: none;\n    margin: 0;\n    padding: 10mm;\n    border: none;\n    font-size: 9pt; /* Adjust base font size for print */\n  }\n  .printable-header h1 {\n    font-size: 16pt;\n  }\n   .printable-header p {\n    font-size: 10pt;\n  }\n  section h2 {\n    font-size: 12pt;\n  }\n  .details-table th,\n  .details-table td {\n    border: 1px solid #aaa !important;\n    padding: 4px; /* Further reduce padding for print */\n  }\n  tr, section, .summary-grid div {\n    page-break-inside: avoid;\n  }\n  h1, h2 {\n    page-break-after: avoid;\n  }\n  .no-print {\n    /* display: none; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
